exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".badge-style---2EeWE {\n  height: 25px;\n  width: 50px;\n  border-radius: 15px;\n  text-align: center;\n  color: rgba(0, 0, 0, .7);\n  font-size: 14px;\n  font-weight: 600; }\n  .badge-style---2EeWE div {\n    padding-top: 3px; }\n", ""]);

// exports
exports.locals = {
	"badge-style": "badge-style---2EeWE"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&localIdentName=[local]---[hash:base64:5]!./~/postcss-loader/lib!./~/sass-loader!./components/badge/badge.scss
// module id = FGgR
// module chunks = 1